export const logDebug = function (...args) {
    const isDebugMode = window.localStorage.getItem('debug_mode') === '1';
    if (!isDebugMode) {
        return;
    }
    console.log(args);
};
